import React, { useState, useEffect } from 'react'
import { Grid } from '@material-ui/core'
import MaterialTable from 'material-table'
import { getIndigenousCommunities } from '../../../../../../services/AsistenciaTecnica/get'

export const Table272 = ({ IdTechnicalAssistanceAnswer }) => {
  const [data, setData] = useState([])

  const getIndigenousCommunitiesList = async () => {
    try {
      const response = await getIndigenousCommunities(
        IdTechnicalAssistanceAnswer,
      )
      if (response.Success) {
        setData(response.Data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (
      IdTechnicalAssistanceAnswer !== '' &&
      IdTechnicalAssistanceAnswer !== null &&
      IdTechnicalAssistanceAnswer !== undefined
    )
      getIndigenousCommunitiesList()
  }, [IdTechnicalAssistanceAnswer])

  const columns = [
    {
      title: 'Comunidad Indígena',
      field: 'Description',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
  ]

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={data}
            onSelectionChange={(selectedRows) => console.log(selectedRows)}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              filtering: true,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',

              exportFileName: 'TableData',
              addRowPosition: 'first',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              toolbarButtonAlignment: 'left',
              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),

              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=" "
          />
        </Grid>
      </Grid>
    </>
  )
}
